<template>
    <div>

        <div class="player-filter scoring-filter">

            <div class="player-filter__top">

                <div class="wrapper">

                    <div class="player-filter__left">

                        <div class="player-filter__switch">
                            <ul>
                                <li>
                                    <a  class="general-button grey-blue generic-medium"
                                        @click.prevent="assoc = 'atp'"
                                        :class="{ active: assoc == 'atp' }"
                                        href="#">
                                        <span>atp</span>
                                    </a>
                                </li>
                                <li>
                                    <a  class="general-button grey-blue generic-medium"
                                        @click.prevent="assoc = 'wta'"
                                        :class="{ active: assoc == 'wta' }"
                                        href="#">
                                        <span>wta</span>
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <div class="player-filter__type">
                            <label for="s2eventSelector" class="vh">Event Selectort</label>
                            <select v-model="selectedEvent"
                                    id="s2eventSelector"
                                    name="s2eventSelector">
                                <!--<option :value="event" v-for="event in events">{{event}}</option>-->
                            </select>
                        </div>

                    </div>

                    <div class="player-filter__right" ref="container" @mouseleave="handleMouseLeave">

                        <button  v-if="pdf_download"
                            class="general-button grey-blue generic-medium pdf_downloads"
                            @click="downloadClick"
                            ref="button">
                            <span v-html="ico_pdf"></span>
                            PDF downloads

                        </button>
                        <ul v-if="pdf_download" class="pdf_downloads__menu"
                            ref="menu"
                            @keydown="menuKeydown">
                            <li v-for="link in pdf_download">
                                <a :href="link.file" target="_blank">
                                    {{link.button_text}}
                                </a>
                            </li>
                        </ul>

                    </div>

                </div>

            </div>

            <div class="scoring-filter__separator"></div>

            <div class="player-filter__bottom">

                <div class="wrapper">

                    <div class="player-filter__type draws-rounds__mobile">
                        <label for="s2roundSelector" class="vh">Round Selector</label>
                        <select v-model="selectedRound"
                                id="s2roundSelector"
                                name="s2roundSelector">
                            <!--<option :value="round" v-for="round in possibleRounds">{{round}}</option>-->
                        </select>
                    </div>

                    <div class="Draw-rounds" v-if="feed.length > 0">
                        <ul>
                            <li v-for="round in rounds">
                                <button class="general-button generic-medium scoring-round"
                                        :class="{ selected: selectedRound == round.id }"
                                        @click.prevent="selectedRound = round.id">
                                    <span>{{round.id}}</span>
                                </button>
                            </li>
                        </ul>
                    </div>

                </div>

            </div>

        </div>

        <div class="wrapper">

            <div class="Draw-group" v-if="feed.length > 0">

                <div class="Draw-round" v-for="(round, roundIndex) in selectedRounds"
                     :class="{ 'Draw-round--drawline' : drawline}">

                    <h2>{{round.id}}</h2>

                    <div v-for="(match, matchIndex) in round.matches">

                        <score-card v-if="showMatch(match)"
                                    :match="match"
                                    mode="draws"
                                    :detail="detail"
                                    :flagPath="flagPath"
                                    :key="match.id">
                        </score-card>
                        <score-line :flagPath="flagPath"
                                    :match="lines[matchIndex]"
                                    :key="match.id"
                                    v-if="showLine(roundIndex, match)">
                        </score-line>
                        <score-empty :rounds="rounds"
                                     :round="round.id"
                                     :lines="lines"
                                     :pos="matchIndex"
                                     :flagPath="flagPath"
                                     :roundPos="roundIndex"
                                     :drawline="drawline"
                                     :key="match.id"
                                     :selectedRound="selectedRound"
                                     v-if="!showMatch(match) && ! showLine(roundIndex, match)">
                        </score-empty>

                    </div>

                </div>

            </div>

            <div class="na" v-else>
                <h2 class="na__title" style="margin-bottom: 0">
                    Draws not available
                </h2>
            </div>
        </div>

    </div>

</template>

<script>
    import axios from 'axios'
    import MatchCard from './MatchCard'
    import MatchLine from './MatchLine'
    import MatchEmpty from './MatchEmpty'

    export default {
        props: ['preassoc', 'flag', 'detail', 'pdf'],
        components: {
            'score-card': MatchCard,
            'score-line': MatchLine,
            'score-empty': MatchEmpty
        },
        data() {
            return {
                draws           : [],
                feed            : [],
                flagPath        : this.flag + '/assets/dist/svg/flags/',
                events          : [],
                selectedEvent   : '',
                selectedRound   : '',
                selectedRounds  : [],
                lines           : [],
                rounds          : [],
                drawline        : false,
                assoc           : this.preassoc,
                ico_pdf         : window.ico_pdf,
                pdf_download    : JSON.parse(this.pdf),
                showDownloads   : false,
            }
        },
        watch: {
            assoc() {
                this.getFeed()
            },
            selectedEvent() {
                this.setupLines()
                this.setupDraws()
            },
            selectedRound(newValue, oldValue) {

                this.reloadRounds(newValue)
            }
        },
        created() {
            this.getFeed()
        },
        mounted() {
            let vm = this
            jQuery('#s2eventSelector').select2({
                width: '100%'
            }).on('change', function () {
                vm.selectedEvent = this.value
            })

            jQuery('#s2roundSelector').select2({
                width: '100%'
            }).on('change', function () {
                vm.selectedRound = this.value
            })

            document.addEventListener('click', this.outsideClick);
        },
        beforeDestroy() {
            document.removeEventListener('click', this.outsideClick);
        },
        methods: {
            showLine(roundIndex, match) {
                return roundIndex == 0 && !this.showMatch(match) && this.drawline
            },
            getFeed() {

                let url = `${window.feed_ip}/get/${this.assoc}/${window.tournament}/draws`

                axios.get( url ).then(response => {

                    this.feed = response.data
                    let feed = response.data

                    this.setupEvents(feed)
                    this.setupLines()
                    this.setupDraws()

                }).catch(function (error) {
                    console.log(error)
                })

            },
            setupEvents(feed) {
                let events = []

                for (let event of feed)
                    events.push(event.description)

                this.events        = events
                this.selectedEvent = events[0]

                if (this.assoc == 'wta') {

                    if(this.feed[1] && this.feed[1].code == "LS"){
                        const temp = events[0];
                        events[0] = events[1];
                        events[1] = temp;
                    }
                    this.selectedEvent = events[0]

                }

                if((typeof window.atp_results_default !== 'undefined') && window.atp_results_default !== "default" && this.assoc == 'atp'){
                    this.selectedEvent = events[Number(window.atp_results_default)]
                }

                if((typeof window.wta_results_default !== 'undefined') && window.wta_results_default !== "default" && this.assoc == 'wta'){
                    this.selectedEvent = events[Number(window.wta_results_default)]
                }

                let vm = this

                jQuery('#s2eventSelector').empty().select2({
                    width: '100%',
                    data: events.map(function (event) {
                        return {
                            id: event,
                            text: event == 'Women\'s Singles Quali' ? 'Women\'s Singles Qualifying' : event
                        }
                    })
                }).val(this.selectedEvent).trigger('change')
            },
            setupLines() {
                let currentEvent = this.getSelectedEvent()

                if (currentEvent.length > 0) {
                    this.lines = currentEvent[0].line
                }

            },
            setupDraws() {

                let currentEvent = this.getSelectedEvent()

                if (currentEvent.length > 0) {

                    this.rounds = currentEvent[0].rounds

                    if( this.rounds[0].id == 'R64' ){

                        this.rounds[0].id = 'Round 1'
                        this.rounds[1].id = 'Round 2'
                        this.rounds[2].id = 'Round 3'

                    }
                    if( this.rounds[0].id == 'R32' ){
                        this.rounds[0].id = 'Round 1'
                        this.rounds[1].id = 'Round 2'
                    }

                    this.selectedRound = currentEvent[0].rounds[0].id

                    jQuery('#s2roundSelector').empty().select2({
                        width: '100%',
                        data: currentEvent[0].rounds.map(function (round) {
                            return {
                                id: round.id,
                                text: round.id
                            }
                        })
                    })

                    this.reloadRounds(currentEvent[0].rounds[0].id)

                }

            },
            reloadRounds(selRound) {

                let eventRounds = this.rounds

                let selectedRoundIndex = eventRounds.findIndex(round => round.id == selRound)
                let selectedRounds = []

                if (selectedRoundIndex == 0) {
                    this.drawline = true
                } else {
                    this.drawline = false
                }

                if (selectedRoundIndex == eventRounds.length - 1) {

                    selectedRounds.push(eventRounds[selectedRoundIndex])

                } else {

                    selectedRounds.push(eventRounds[selectedRoundIndex])
                    selectedRounds.push(eventRounds[selectedRoundIndex + 1])

                }

                jQuery('#s2roundSelector').val(selRound).trigger('change')

                this.selectedRounds = selectedRounds

            },
            getSelectedEvent() {

                return this.feed.filter(event => event.description == this.selectedEvent)

            },

            showMatch(match) {

                if (!match.detail) {
                    return false
                }

                if (match.detail.state == 'P') {
                    return true
                }

                if (match.detail == undefined) {
                    return false
                }

                if (match.detail == '') {
                    return false
                }

                if (match.detail.state == 'F') {
                    return true
                }

            },
            downloadClick(event) {
                let thisEl = jQuery(event.target),
                parentEl = thisEl.parent();


                if (parentEl.hasClass('open')) {
                    parentEl.removeClass('open').next().slideUp();
                } else {
                    jQuery('.drawer__nav .open').removeClass('open').next().slideUp();
                    parentEl.addClass('open').next().slideDown(() => {
                        parentEl.next().find('a:first').focus(); // Set focus on the first menu item
                    });
                }

                event.preventDefault(); // Prevent any default behavior
            },

            menuKeydown(event) {
                if (event.keyCode === 9 && event.shiftKey) { // Shift + Tab key
                    const menuItems = jQuery(this.$refs.menu).find('a');
                    if (menuItems.length > 0 && document.activeElement === menuItems[0]) {
                        event.preventDefault();
                        jQuery(this.$refs.button).focus(); // Set focus on the button
                    }
                } else if (event.keyCode === 9 && !event.shiftKey) { // Tab key
                    const menuItems = jQuery(this.$refs.menu).find('a');
                    if (menuItems.length > 0 && document.activeElement === menuItems[menuItems.length - 1]) {
                        event.preventDefault();
                        jQuery(this.$refs.button).focus(); // Set focus on the button
                    }
                }
            },

            outsideClick(event) {
                const container = jQuery(this.$refs.container);
                if (!container.is(event.target) && !container.has(event.target).length) {
                    container.removeClass('open').find('.pdf_downloads__menu').slideUp();
                }
            },
            handleMouseLeave() {
                const container = jQuery(this.$refs.container)
                container.removeClass('open').find('.pdf_downloads__menu').slideUp();
            }
        }
    }
</script>
